import { render, staticRenderFns } from "./BasePostLogin.vue?vue&type=template&id=069db133&scoped=true"
import script from "./BasePostLogin.vue?vue&type=script&lang=js"
export * from "./BasePostLogin.vue?vue&type=script&lang=js"
import style0 from "./BasePostLogin.vue?vue&type=style&index=0&id=069db133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069db133",
  null
  
)

export default component.exports